import React, { useState, useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
import DeleteIcon from "@mui/icons-material/Delete";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import {
  IconButton,
  Tooltip,
  TableCell,
  Checkbox,
  TableRow,
  Table,
  TableBody,
  TableHead,
  Paper,
  TableContainer,
  Autocomplete,
  Toolbar,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import {
  MAPLOCATION_API_01,
  TAX_API_01,
  TAX_API_03,
  TAX_API_04,
  TAX_API_05,
} from "../../api/ApiModel";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";

function MapTaxandCharges() {
  const [errors, setErrors] = useState({});
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedRows, setSelectedRows] = useState([]); // To track selected rows
  const [selectedTaxType, setSelectedTaxType] = useState(null);
  const [rows1, setRows1] = useState([]);
  const navigate = useNavigate();
  const [sequenceValue, setSequenceValue] = useState("");
  const [selectedLOC, setSelectedLOC] = useState("");
  const [dataloc, setDataloc] = useState([]);
  const theme = useTheme();
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, RESTCODE, USERREFCODE, USERNAME } =
    SYS_USER.USER_PARAM || {};
  const styles = useStyles(theme);
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    TAXPAGECODE: "",
    // GROUPCODE: "",
    // GROUPNAME: "",
  });

  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);

  const gotToPage = () => {
    navigate("/ViewtaxCharges");
  };

  useEffect(() => {
    fetchData();
  }, []);

  //-------------------functions----------------
  const fetchData = async () => {
    try {
      const result = await externalgetApi(TAX_API_03, "get");
      setData(result);
    } catch (err) {
      setError(err);
    }
  };

  const handleClearClick = () => {
    //clear text filed function goes here
    alert("add Clear button click event");
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(TAX_API_01, "get", {
          COMPCODE,
          LOCCODE: selectedLOC.LOCCODE,
          STS: CON_STATUS_ACTIVE,
        });
        setData1(result); // Ensure result is an array
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [selectedLOC.LOCCODE]);

  const handleTaxTypeChange = (event) => {
    setSelectedTaxType(event.target.value);
  };

  const handleSelectionloc = (newvalue) => {
    setSelectedLOC(newvalue);
    console.log("Selected value:", newvalue);

    // Pass the selected value to any required function here
  };

  const handleSelectionChange = (event, value) => {
    setSelectedValue(value);
    console.log("Selected value:", value);
    // Pass the selected value to any required function here
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
  };
  if (selectedValue) {
    console.log("Selected TAXPAGECODE:", selectedValue.TAXPAGECODE);
  }
  useEffect(() => {
    fetchDatatax();
  }, [selectedValue, selectedLOC]); // Add selectedValue to the dependency array

  const fetchDatatax = async () => {
    if (!selectedValue) {
      console.log("No selectedValue, skipping API call.");
      return; // Skip fetch if selectedValue is null or undefined
    }

    try {
      const result = await externalgetApi(TAX_API_04, "get", {
        COMPCODE,
        LOCCODE: selectedLOC.LOCCODE,
        TAXPAGECODE: selectedValue.TAXPAGECODE || "0", // Use selectedValue dynamically
        STS: CON_STATUS_ACTIVE,
      });
      setData2(result || []); // Ensure result is an array
      console.log("Fetched data for TAXPAGECODE:", result);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(`Failed to load options: ${err.message || err}`);
    } finally {
      setIsLoading(false);
    }
  };
  const [tableData, setTableData] = useState([]);

  const handleConfirmClick = () => {
    // Capture the data to store in sessionStorage
    const dataToStore = {
      taxPageName: selectedValue?.TAXPAGENAME,
      taxpagecode: selectedValue?.TAXPAGECODE,
      taxType: selectedTaxType?.TAXTYPE,
      taxCode: selectedTaxType?.TAXCODE,
      taxRate: selectedTaxType?.TAXRATE,
      taxAppliedfor: selectedTaxType?.TAXAPPLIEDFOR,
      sequence: sequenceValue, // Capture the sequence value
    };

    // Get the current data from sessionStorage
    const storedData = sessionStorage.getItem("tableData");
    const existingData = storedData ? JSON.parse(storedData) : [];

    // Add the new data to the existing table data
    const updatedData = [...existingData, dataToStore];

    // Update sessionStorage with the new table data (including the new row)
    sessionStorage.setItem("tableData", JSON.stringify(updatedData));

    // Update the tableData state to reflect the changes
    setTableData(updatedData);

    // Reset the form values
    //setSelectedValue(null);  // Reset the selectedValue state
    setSelectedTaxType(null); // Reset the selectedTaxType state
    setSequenceValue(""); // Reset the sequence value field
  };

  useEffect(() => {
    // On component mount, load the data from sessionStorage
    const storedData = sessionStorage.getItem("tableData");

    if (storedData) {
      // If sessionStorage contains data, parse and set it to state
      const parsedData = JSON.parse(storedData);
      setTableData(parsedData);
    } else {
      // If no data is found, initialize the tableData as an empty array
      setTableData([]);
    }
  }, []);

  const handleRemoveRow = (index) => {
    // Filter out the row to delete from the tableData
    const updatedData = tableData.filter((_, i) => i !== index);

    // Update the tableData state
    setTableData(updatedData);

    // Immediately update sessionStorage with the updated table data
    sessionStorage.setItem("tableData", JSON.stringify(updatedData));
  };

  const handleSubmit = async () => {
    // Format the table data to match the required API structure
    const formattedData = {
      taxtypesequenceDt: tableData.map((row) => ({
        taxpagecode: row.taxpagecode || "", // Replace with actual property names
        COMPCODE,
        LOCCODE: selectedLOC.LOCCODE,
        taxcode: String(row.taxCode), // Ensure `taxCode` is a string
        SEQ: row.sequence, // Convert `seq` to an integer with a fallback
      })),
      COMPCODE,
      LOCCODE: selectedLOC.LOCCODE,
      lOCDATE: new Date().toISOString().split("T")[0], // Format date as YYYY-MM-DD
    };

    try {
      // Make a POST request to the API
      const response = await externalpostApi(TAX_API_05, formattedData);

      // Handle successful response
      console.log("Success:", response.data);

      // Clear session storage permanently
      sessionStorage.clear();

      // Reset table data
      setTableData([]);

      // Fetch updated data
      fetchDatatax();

      // Optionally, display a success message
      console.log("Data submitted successfully and session storage cleared.");
    } catch (error) {
      // Handle error
      console.error("Error:", error);

      // Optionally, display an error message
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(MAPLOCATION_API_01, "get", {
          COMPCODE,
          USERREFCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE, // Fetch only items where STS is 'A'
        });

        setDataloc(result); // Populate orderData with the updated array
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Tax</Link>
                <Link underline="none">Map Tax and Charges</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack2,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                  id="btnback"
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.box_container_add}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              sx={{
                ...styles.col_title,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {" "}
              {/* <Grid item xs={12} sm={7} md={7}> */}
              <Typography variant="title" align="left">
                Map Tax and Charges Types
              </Typography>
              {/* </Grid> */}
              <Grid item xs={12} sm={3} md={3}>
                <Autocomplete
                  options={Array.isArray(dataloc) ? dataloc : []}
                  getOptionLabel={(option) => option.LOCATION || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Location"
                      size="small"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                  onChange={(event, newValue) => {
                    handleSelectionloc(newValue); // Update the state correctly
                  }}
                  value={
                    Array.isArray(dataloc) && dataloc.length > 0
                      ? selectedLOC
                      : null
                  }
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                  noOptionsText={
                    <div
                      style={{
                        backgroundColor: theme.palette.background.paper,
                        padding: "8px",
                      }}
                    >
                      No options
                    </div>
                  }
                  loading={isLoading}
                />
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={5}>
            <Box
              p={2}
              sx={{
                ...styles.col_1,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                textAlign: "left",
                padding: 2,
                marginLeft: 0,

                height: {
                  xs: "auto",
                  sm: "auto",
                  md: "32vh",
                  lg: "32vh",
                  xl: "32vh",
                },
                borderRadius: "4px",
                boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
                background: theme.palette.background.paper,

                borderRight: theme.palette.divider,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Autocomplete
                    options={Array.isArray(data) ? data : []}
                    getOptionLabel={(option) => option.TAXPAGENAME || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Tax / Charges Page Name"
                        size="small"
                        variant="outlined"
                      />
                    )}
                    onChange={handleSelectionChange}
                    value={
                      selectedValue ||
                      (Array.isArray(data)
                        ? data.find(
                            (item) =>
                              item.TAXPAGECODE === selectedValue?.TAXPAGECODE
                          ) || null
                        : null)
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.TAXPAGECODE === value?.TAXPAGECODE
                    }
                    ListboxProps={{
                      style: {
                        maxHeight: 150,
                        backgroundColor: theme.palette.background.paper,
                      },
                    }}
                    noOptionsText={
                      <div
                        style={{
                          backgroundColor: "theme.palette.background.paper",
                          padding: "8px",
                        }}
                      >
                        No options
                      </div>
                    }
                    loading={isLoading}
                  />
                </Grid>
                <Grid item xs={12}>
                  {isLoading ? (
                    <CircularProgress />
                  ) : (
                    <Autocomplete
                      options={data1} // Array of options
                      getOptionLabel={(option) => option.TAXTYPE || ""} // Only display TAXTYPE in the dropdown
                      value={selectedTaxType} // The selected option object, which includes TAXRATE
                      onChange={(event, newValue) => {
                        setSelectedTaxType(newValue); // Store the entire option, including TAXRATE
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Tax / Charges Type"
                          size="small"
                          variant="outlined"
                          error={false}
                          helperText={null}
                        />
                      )}
                      ListboxProps={{
                        style: {
                          maxHeight: 150,
                          backgroundColor: "#fff",
                        },
                      }}
                      noOptionsText={
                        <div style={{ padding: "8px" }}>
                          No tax types available
                        </div>
                      }
                    />
                  )}
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    id="txtseq"
                    label="Sequence"
                    size="small"
                    fullWidth
                    variant="outlined"
                    name="VOUCHERNO"
                    // Use the `value` prop if you need to bind it to a state
                    value={sequenceValue} // You can use state to hold the value if required
                    onChange={(e) => setSequenceValue(e.target.value)} // Capture the value
                    InputLabelProps={{ sx: { ...theme.typography.body2 } }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    sx={styles.btn_primary}
                    size="medium"
                    variant="contained"
                    onClick={handleConfirmClick}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={7}>
            <Box p={1} sx={{ ...styles.st_page_table, height: "32vh" }}>
              <TableContainer component={Paper}>
                <Table stickyHeader aria-label="simple table">
                  <TableHead>
                    <TableRow
                      sx={{ background: theme.palette.background.paper }}
                    >
                      <TableCell sx={{ fontWeight: "bold", maxWidth: "100px" }}>
                        Tax / Charge Type
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="right">
                        Tax / Charges Rate[%]
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="right">
                        Applied For
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="right">
                        Sequence
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {isLoading ? (
                      <TableRow>
                        <TableCell colSpan={4} align="center">
                          Loading...
                        </TableCell>
                      </TableRow>
                    ) : error ? (
                      <TableRow>
                        <TableCell colSpan={4} align="center">
                          {/* Error: {error} */}
                        </TableCell>
                      </TableRow>
                    ) : (
                      data2.map((row) => (
                        <TableRow key={row.TAXCODE}>
                          {" "}
                          {/* Use a unique key, like TAXCODE */}
                          <TableCell>{row.TAXTYPE}</TableCell>{" "}
                          {/* Tax / Charge Type */}
                          <TableCell align="right">
                            {row.TAXRATE}
                          </TableCell>{" "}
                          {/* Tax Rate */}
                          <TableCell align="right">
                            {row.TAXAPPLIEDFOR}
                          </TableCell>{" "}
                          {/* Applied For */}
                          <TableCell align="right">{row.SEQ}</TableCell>{" "}
                          {/* Sequence */}
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Box p={1} sx={{ ...styles.st_page_table, height: "32vh" }}>
              <TableContainer component={Paper}>
                <Toolbar
                  sx={{
                    maxWidth: "100%",
                    pl: { sm: 2, md: 2 },
                    pr: { xs: 1, sm: 1 },
                    background: theme.palette.background.paper,
                  }}
                >
                  <Typography
                    variant="title"
                    component="div"
                    sx={{
                      color: theme.palette.text.primary,
                      flex: "1 1 100%",
                      ml: 1,
                    }}
                  >
                    Map Tax
                  </Typography>
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="flex-end"
                    // p={2}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        background: theme.palette.primary.main,
                        color: theme.palette.text.buttontxt,
                        textTransform: "capitalize",
                        width: "120px",
                      }}
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  </Stack>
                </Toolbar>
                <Table stickyHeader aria-label="simple table">
                  <TableHead>
                    <TableRow
                      sx={{ background: theme.palette.background.paper }}
                    >
                      <TableCell sx={{ fontWeight: "bold", maxWidth: "100px" }}>
                        Tax / Charge Type
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="right">
                        Tax / Charges Rate[%]
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="right">
                        Applied For
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="right">
                        Sequence
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="right">
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={5} align="center"></TableCell>
                      </TableRow>
                    ) : (
                      tableData.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{row.taxType}</TableCell>
                          <TableCell align="right"> {row.taxRate} </TableCell>
                          <TableCell align="right">
                            {" "}
                            {row.taxAppliedfor}{" "}
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              display: "none", // Hides the cell for all screen sizes
                            }}
                          >
                            {row.taxCode}
                          </TableCell>{" "}
                          <TableCell
                            align="right"
                            sx={{
                              display: "none", // Hides the cell for all screen sizes
                            }}
                          >
                            {row.taxpagecode}
                          </TableCell>
                          <TableCell align="right">{row.sequence}</TableCell>
                          <TableCell align="right">
                            <Tooltip title="Delete" arrow>
                              <IconButton
                                onClick={() => handleRemoveRow(index)}
                              >
                                <DeleteIcon
                                  sx={{ color: theme.palette.system.danger }}
                                />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default MapTaxandCharges;
